import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Redirect } from 'react-router-dom';

import { authOperations, authSelectors } from 'auth/duck';

import logoTeal from 'assets/img/TC_Logo_Concierge.png';

type ReduxProps = ConnectedProps<typeof connector>;
type Props = ReduxProps & WithStyles<typeof styles>;

interface LoginLocationState {
  from?: { pathname: string };
}

const Login: React.FunctionComponent<Props> = ({
  requestIdpMetadata,
  loginUrl,
  classes,
  fetchingAuth,
  fetchingMessages,
  token,
  location,
}) => {
  React.useEffect(() => {
    requestIdpMetadata();
  }, [requestIdpMetadata]);

  const handleClick = () => {
    window.location.assign(loginUrl);
  };

  const state = location.state as LoginLocationState;
  const { pathname } = state?.from || { pathname: '/' };
  if (token) return <Redirect to={{ pathname }} />;

  return !fetchingMessages ? (
    <Grid
      className={classes.loginContainer}
      container={true}
      spacing={0}
      direction="column"
      alignItems="center"
      justify="space-evenly"
    >
      <Grid item={true}>
        <img src={logoTeal} style={{ width: '100%' }} alt="travelcoup logo" />
      </Grid>
      <Grid
        className={classes.loginContent}
        container={true}
        direction="column"
        justify="space-around"
      >
        <Grid item={true} style={{ textAlign: 'center' }}>
          <Button
            className={classes.loginButton}
            color="primary"
            disabled={fetchingAuth}
            onClick={handleClick}
            variant="contained"
          >
            Log in
          </Button>
        </Grid>
      </Grid>
    </Grid>
  ) : null;
};

const styles = (theme: Theme) =>
  createStyles({
    landingActions: {
      '& > *': { color: '#fff' },
      '& > a': { margin: '0px 12px' },
      textAlign: 'center',
    },
    loginButton: {
      background: '#ff5722',
      fontSize: theme.typography.pxToRem(18),
      minHeight: 60,
      minWidth: 180,
      padding: '12px 36px',
    },
    loginContainer: {
      background: '#000000',
      height: '100vh',
    },
    loginContent: {
      height: '30vh',
      maxHeight: 300,
    },
  });

const mapState = (state: RootState) => ({
  fetchingAuth: state.auth.isFetching,
  fetchingMessages: state.intl.isFetching,
  idp_configuration: state.auth.configuration,
  location: state.router.location,
  loginUrl: authSelectors.loginSelector(state),
  token: state.auth.access_token,
});

const mapDispatch = {
  requestIdpMetadata: authOperations.getIdpMetadata,
};

const connector = connect(mapState, mapDispatch);

export default withStyles(styles)(connector(Login));
